import { AutomationContextlessPoliciesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useAutomationContextlessPolicies = () => {
  const { data, loading } = useQuery(AutomationContextlessPoliciesDocument)
  const policies = data?.automations?._policies

  return {
    loading,
    manageCustomNotifications: !!policies?.manageCustomNotifications.can,
  }
}
